export default __webpack_public_path__ + "static/media/bridge.78e1b184.svg";